import { cn, formatDateTime, relativeTime } from '@/lib/format'

export interface RelativeTimeProps {
  value: string | null | undefined
  /** Shown when there's no value. */
  fallback?: string
  /** Mark it (warn colour) when older than this many days: stale logins, quiet tenants. */
  staleAfterDays?: number
  className?: string
}

/** <time> with a relative label and the exact date/time as a tooltip. */
export function RelativeTime({ value, fallback = 'Never', staleAfterDays, className }: RelativeTimeProps) {
  if (!value) return <span className={cn('text-subtle', className)}>{fallback}</span>
  const ageDays = (Date.now() - new Date(value).getTime()) / 86_400_000
  const stale = staleAfterDays !== undefined && ageDays > staleAfterDays
  return (
    <time dateTime={value} title={formatDateTime(value)} className={cn('tabular', stale && 'text-warn', className)}>
      {relativeTime(value)}
    </time>
  )
}
